import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { ApiCaller } from '@graphit/callers'

export const AppDown: React.FC = () => {
	const { t } = useTranslation()

	useEffect(() => {
		async function ping() {
			try {
				await ApiCaller.ping()
				window.location.href = '/'
			} catch (err) {
				return
			}
		}

		const interval = setInterval(ping, 5000)

		return () => {
			clearInterval(interval)
		}
	}, [])

	return (
		<div className="flex flex-col items-center justify-center h-screen m-auto max-w-lg text-center p-8">
			<div className="text-xl mt-4">{t('appdown.message')}</div>
		</div>
	)
}
